import { call, delay, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';


function * automatedSearchAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/search', data.payload)
  if(api.data.user_workspace!=undefined){yield put({type:'REQUEST_USER_WORKSPACE_SUCCESS', val:api.data.user_workspace})}
  //if(data.payload.preview==true){yield put({type:'REQUEST_AUTOMATED_SEARCH_PREVIEW', id:api.data.id, repeat:true, search:data.payload.search, list_id:api.data.list_id});}
  //else{
  if(api.data.checkout!=undefined && api.data.checkout!=null){
    window.location.href=api.data.checkout;
  }else{
    yield put({type:'REQUEST_PENDING_JOBS', val:true})
    yield put({type:'REQUEST_AUTOMATED_SEARCH_SUCCESS'})
  }
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * automatedSearchPreviewAsync(data){ let apiResult = 'wait';
  while (apiResult=='wait') {
    try {const response = yield call([axios, axios.get], '/api/uploads/batches/show/preview/' + data.id); apiResult = response.data; // Assuming the API response is in the `data` property
        } catch (error) {yield put({type:'REQUEST_ERROR', val:error.response});}
    console.log(apiResult, 'API RESULT');
    if(apiResult=='wait') {yield delay(1500);}
  }
  console.log('API RESULT', apiResult);
  yield put({ type: 'REQUEST_AUTOMATED_SEARCH_PREVIEW_SUCCESS', val:apiResult, id:data.id});
}

function * companyDeleteAsync(data){
  try{
    const api = yield call([axios, axios.delete], '/api/companies/'+data.id)
    yield put({type:'REQUEST_COMPANY_DELETE_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_DELETE_COMPANIES_FAIL', val:api.data});
    yield put({type:'REQUEST_SPECIFIC_ERROR', message:error.response.data.error})
  }
}


function * companyCreateAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/companies', data.payload)
    yield put({type:'REQUEST_COMPANY_CREATE_SUCCESS', val:api.data});
    if(api.data.company.status!=undefined && api.data.company.status!='NONE'){yield(put({type:'UPDATE_SCORECARD_NEW_PROSPECT'}));}
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}


function * companyCreateBatchAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/companies/batch', createStream(data.batch), {headers:{'Content-Type':'application/octet-stream'}});
    yield put({type:'REQUEST_PENDING_JOBS', val:true})
    yield put({type:'REQUEST_COMPANY_CREATE_BATCH_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response});
  }
}

function * companyGetAsync(data){
  try{
  const api = yield call([axios, axios.get], '/api/company'+data.query)
  yield put({type:'REQUEST_COMPANY_GET_SUCCESS', val:api.data.company});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * companyUpdateAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/companies/'+data.id, data.payload)
    if(api.data.error!=undefined){
        if(api.data.error=='merge_needed'){
              yield put({type:'REQUEST_COMPANY_UPDATE_MERGE_PROMPT', val:{company_id:data.id, merge_needed:api.data.company}})
              //yield put({type:'REQUEST_SPECIFIC_ERROR', message:'Company: '+api.data.company.name+' is already saved against this website '+api.data.company.website+'. Try using listing websites instead.'})
        }else{yield put({type:'REQUEST_ERROR', val:error.response})}
    }else{
            yield put({type:'REQUEST_COMPANY_UPDATE_SUCCESS', val:api.data.company});
            if(api.data.deal!=undefined){
              yield put({type:'REQUEST_CREATE_DEAL_SUCCESS', val:api.data.deal});
              yield put({type:'UPDATE_SCORECARD_CREATE_DEAL', val:api.data.deal});
            }
            yield put({type:'REQUEST_INDEX_DEALS', company_id:api.data.company.id});

            if(data.original_company!=undefined && (data.original_company.status==undefined || data.original_company.status==='NONE') && (api.data.company.status!=undefined && api.data.company.status!='NONE')){yield(put({type:'UPDATE_SCORECARD_NEW_PROSPECT'}));}

            if(api.data.timeline_items.length>0){
              yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});
            }
            for(let ti of api.data.deleted_timeline_items){
              yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));
            }
            yield put({type:'REQUEST_SALES_COACH_REFRESH'});
    }
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * companiesIndexAsync(data){
  try{
  let filter=data.encoded_filter; if(data.filter!=undefined){filter=btoa(encodeURIComponent(JSON.stringify(data.filter)))}
  let order=data.encoded_order; if(data.order!=undefined){order=btoa(encodeURIComponent(JSON.stringify(data.order)));}
  let url='/api/companies?timezone='+getTimezone()+'&';
  if(data.page!=undefined){url=url+'page='+data.page+'&'}
  if(data.last_request!=undefined){url=url+'T='+btoa(encodeURIComponent(data.last_request))+'&'}
  if(data.rowsPerPage!=undefined){url=url+'rowsPerPage='+data.rowsPerPage+'&'}
  //if(data.list_id!=undefined){url=url+'lid='+data.list_id+'&'}
  if(data.query!=undefined){url=url+'q='+data.query+'&'}
  if(order!=undefined){url=url+'o='+order+'&'}
  if(filter!=undefined){url=url+'f='+filter+'&'}
  if(data.filter_id!=undefined){url=url+'fid='+data.filter_id+'&'}
  if(window.location.href.includes('/companies/table')==true){url=url+'list_view=true&'}
  let cid=window.location.href.split('/cid/')[1]; if(cid!=undefined){url=url+'cid='+cid.split('/')[0]+'&';}
  url = url.substring(0, url.length - 1);
  const api = yield call([axios, axios.get], url)
  yield put({type:'REQUEST_INDEX_COMPANIES_SUCCESS', val:{...api.data, ...api.data.data, filter:data.filter, list_id:data.list_id, query:data.query, filter_id:data.filter_id, order:data.order}});
  
}catch(error){console.log(error, 'ERROR');
  console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * companiesAssignAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/companies/assign', data.payload)
  yield put({type:'REQUEST_ASSIGN_COMPANIES_SUCCESS', val:api.data});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * companiesDeleteAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/companies/delete', data.payload)
  window.location.reload();
  yield put({type:'REQUEST_DELETE_COMPANIES_SUCCESS', val:api.data});
}catch(error){console.log(error, error.response, error.response.data.error, 'ERROR');
  yield put({type:'REQUEST_DELETE_COMPANIES_FAIL'});
  yield put({type:'REQUEST_SPECIFIC_ERROR', message:error.response.data.error})
}
}

function * companiesEditFieldAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/companies/editField', data.payload)
  yield put({type:'REQUEST_EDIT_FIELD_COMPANIES_SUCCESS', val:api.data});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}


function * companiesMoveAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/companies/move', data.payload)
  yield put({type:'REQUEST_MOVE_COMPANIES_SUCCESS', val:api.data});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * companiesShareAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/companies/share', data.payload)
  yield put({type:'REQUEST_SHARE_COMPANIES_SUCCESS', val:api.data});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * contactDeleteAsync(data){
  try{
  const api = yield call([axios, axios.delete], '/api/contacts/'+data.id+'/'+data.company_id)
  yield put({type:'REQUEST_CONTACT_DELETE_SUCCESS', val:api.data});
  yield put({type:'REQUEST_INDEX_DEALS', company_id:data.company_id});
  yield put({type:'REQUEST_SALES_COACH_REFRESH'});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * contactCreateAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/contacts', data.payload)
    yield put({type:'REQUEST_CONTACT_CREATE_SUCCESS', val:api.data.contact});
    yield put({type:'REQUEST_INDEX_DEALS', company_id:data.payload.company_id});
    yield put({type:'REQUEST_SALES_COACH_REFRESH'});
    if(api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});}
  }catch(error){console.log(error, 'ERROR');
    if(error.response.data!=undefined && error.response.data.error!=undefined){
      yield put({type:'SET_SNACKBAR', val:{open:true, type:'error', message:error.response.data.error}});
      yield put({type:'REQUEST_CONTACT_FAIL'});
    }else if(error.response.data!=undefined && error.response.data.errors!=undefined){
      yield put({type:'SET_SNACKBAR', val:{open:true, type:'error', message:error.response.data.errors[0]}});
      yield put({type:'REQUEST_CONTACT_FAIL'});
    }
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * companyMergeAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/companies/merge', data.payload)
    window.location.reload();
  }catch(error){console.log(error, 'ERROR'); yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * contactMergeAsync(data){
  try{
  const api = yield call([axios, axios.put], '/api/contacts/merge', data.payload)
  yield put({type:'REQUEST_CONTACT_MERGE_SUCCESS', val:api.data.contact});
  if(api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});}
  for(let ti of api.data.deleted_timeline_items){
    yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));
  }
  yield put({type:'REQUEST_INDEX_DEALS', company_id:data.payload.company_id});
  yield put({type:'REQUEST_SALES_COACH_REFRESH'});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * contactUpdateAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/contacts/'+data.id, data.payload)
    yield put({type:'REQUEST_CONTACT_UPDATE_SUCCESS', val:api.data.contact});
    if(api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});}
    for(let ti of api.data.deleted_timeline_items){
      yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));
    }
    yield put({type:'REQUEST_INDEX_DEALS', company_id:data.payload.company_id});
    yield put({type:'REQUEST_SALES_COACH_REFRESH'});
  }catch(error){console.log(error, 'ERROR');
    console.log(error);
    if(error.response.data!=undefined && error.response.data.error!=undefined){
      yield put({type:'SET_SNACKBAR', val:{open:true, type:'error', message:error.response.data.error}});
      yield put({type:'REQUEST_CONTACT_FAIL'});
    }else if(error.response.data!=undefined && error.response.data.errors!=undefined){
      yield put({type:'SET_SNACKBAR', val:{open:true, type:'error', message:error.response.data.errors[0]}});
      yield put({type:'REQUEST_CONTACT_FAIL'});
    }
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}


function * timelineItemsGetAsync(data){
  try{
  const api = yield call([axios, axios.get], '/api/company/'+data.company_id+'/timeline_items')
  yield put({type:'REQUEST_TIMELINE_ITEMS_GET_SUCCESS', company_id:data.company_id, val:api.data});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}


function * contactIndexAsync(data){
  try{
    const api = yield call([axios, axios.get], '/api/company/'+data.company_id+'/contacts')
    yield put({type:'REQUEST_CONTACTS_INDEX_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function * timelineItemCreateAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/timeline_items/'+data.timeline_type, data.payload)
    api.data.company_id=data.payload.company_id;
    yield put({type:'REQUEST_TIMELINE_ITEM_CREATE_SUCCESS_QUEUE', val:api.data});
    yield put({type:'REQUEST_TIMELINE_ITEM_CREATE_SUCCESS', val:api.data});
    if(api.data.contact!=undefined){
      yield put({type:'REQUEST_CONTACT_LOAD'});
      yield put({type:'REQUEST_CONTACT_UPDATE_SUCCESS', val:{...api.data.contact, pivot:{company_id:data.payload.company_id}}});
    }
    //COMPLETE TASK
    yield put({type:'REQUEST_COMPLETE_TASK_SUCCESS', val:api.data}); if(api.data.completed_task!=undefined){yield put({type:'UPDATE_SCORECARD_TASK_COMPLETED', val:api.data.completed_task});}

    for(let ti of api.data.timeline_items){
      yield put({type:'REQUEST_SELECTED_TIMELINE_ITEM', val:ti.id});
      yield put({type:'UPDATE_SCORECARD_TIMELINE_ITEM', val:ti});
    }
    //REFRESH DEAL;
    if(api.data.deleted_timeline_items!=undefined){for(let ti of api.data.deleted_timeline_items){yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));}}
    if(api.data.refresh_deal!=undefined && api.data.refresh_deal!=null){ yield put({type:'REQUEST_UPDATE_DEAL_SUCCESS', val:api.data.refresh_deal}); yield put({type:'REQUEST_SALES_COACH_REFRESH'});}
    else{yield put({type:'REQUEST_INDEX_DEALS', company_id:data.payload.company_id});}
    if(data.timeline_type=='emails'){
      yield delay(5000);
      yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id}); //UPDATE DELIVERED STATUS AFTER 5 SECONDS
    }
    if (api.data.error_message != undefined && api.data.error_message != null) {
      yield put({ type: 'REQUEST_ERROR', error_message: api.data.error_message });
    }

}catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}

function * timelineItemUpdateAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/timeline_items/'+data.timeline_type+'/'+data.id, data.payload)
    api.data.company_id=data.payload.company_id;
    yield put({type:'REQUEST_TIMELINE_ITEM_CREATE_SUCCESS_QUEUE', val:api.data});
    yield put({type:'REQUEST_TIMELINE_ITEM_UPDATE_SUCCESS', val:api.data});
    if(api.data.contact!=undefined){
      yield put({type:'REQUEST_CONTACT_LOAD'});
      yield put({type:'REQUEST_CONTACT_UPDATE_SUCCESS', val:{...api.data.contact, pivot:{company_id:data.payload.company_id}}});
    }
    //CREATE DELETE TIMELINE ITEMS;
    if(api.data.timeline_items!=undefined && api.data.timeline_items.length>0){
      yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data});
     for(let ti of api.data.timeline_items){yield put({type:'REQUEST_SELECTED_TIMELINE_ITEM', val:ti.id});}
    }
    if(api.data.deleted_timeline_items!=undefined){for(let ti of api.data.deleted_timeline_items){yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));}}
    //REFRESH DEAL;
    if(api.data.refresh_deal!=undefined && api.data.refresh_deal!=null){ yield put({type:'REQUEST_UPDATE_DEAL_SUCCESS', val:api.data.refresh_deal}); yield put({type:'REQUEST_SALES_COACH_REFRESH'});}
    else{yield put({type:'REQUEST_INDEX_DEALS', company_id:data.payload.company_id});}
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}




function * timelineItemDeleteAsync(data){
  try{
  let extra_params=''; if(data.extra_data!=undefined && data.extra_data.send_notifications){extra_params='?send_notifications='+data.extra_data.send_notifications;}
  const api = yield call([axios, axios.delete], '/api/timeline_items/'+data.timeline_type+'/'+data.id+extra_params)
  yield put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:api.data});
  if(api.data.contact!=undefined){
    yield put({type:'REQUEST_CONTACT_LOAD'});
    yield put({type:'REQUEST_CONTACT_UPDATE_SUCCESS', val:{...api.data.contact, pivot:{company_id:data.company_id}}});
  }
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * taskCompleteAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/timeline_items_complete_task', data.payload)
  //COMPLETE TASK
  yield put({type:'REQUEST_COMPLETE_TASK_SUCCESS', val:api.data}); if(api.data.completed_task!=undefined){yield put({type:'UPDATE_SCORECARD_TASK_COMPLETED', val:api.data.completed_task});}
  //CREATE DELETE TIMELINE ITEMS;
  if(api.data.timeline_items!=undefined && api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data}); for(let ti of api.data.timeline_items){yield put({type:'REQUEST_SELECTED_TIMELINE_ITEM', val:ti.id});}}if(api.data.deleted_timeline_items!=undefined){for(let ti of api.data.deleted_timeline_items){yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));}}
  //REFRESH DEAL;
  if(api.data.refresh_deal!=undefined && api.data.refresh_deal!=null){ yield put({type:'REQUEST_UPDATE_DEAL_SUCCESS', val:api.data.refresh_deal}); yield put({type:'REQUEST_SALES_COACH_REFRESH'});}
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * sendEmailNowAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/sendEmailNow/'+data.timeline_item.id)
  yield put({type:'REQUEST_SEND_EMAIL_NOW_SUCCESS', val:{timeline_item:{company_id:data.timeline_item.company_id, ...api.data}}});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * cancelEmailNowAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/cancelEmailNow/'+data.timeline_item.id)
  yield put({type:'REQUEST_CANCEL_EMAIL_NOW_SUCCESS', val:{timeline_item:{company_id:data.timeline_item.company_id, ...api.data}}});
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * addToCompaniesAsync(data){
  try{
  const api = yield call([axios, axios.post], '/api/companies/addToCompanies', data.payload)
  yield put({type:'SET_SNACKBAR', val:{open:true, message:'Operation completed', type:'success'}});
  window.location.href=window.location.href;
}catch(error){console.log(error, 'ERROR');
  yield put({type:'REQUEST_ERROR', val:error.response})
}
}

function * enrichEmailsAsync(data){
  try{
    yield put({type:'REQUEST_LOAD_CONTACTS'});
    const api = yield call([axios, axios.get], '/api/emailEnrichment/process/'+data.company_id+'/'+data.enrich_type+'/'+JSON.stringify(data.departments)+'/'+data.only_personal+'/'+data.count+'/'+data.auto_verify)
    yield put({type:'REQUEST_CONTACTS_INDEX_SUCCESS', val:api.data});
    yield put({type:'REQUEST_COMPANY_UPDATE_SUCCESS', val:api.data});
    if (data.auto_verify === true) {
      yield put({type:'RESTRICT_BULK_VERIFY', val:true, company_id:data.company_id});
      yield delay(3000);
      yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
      yield delay(3000);
      yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
      yield delay(3000);
      yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
      yield delay(5000);
      yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
      yield delay(10000);
      yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
      yield delay(20000);
      yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
      yield put({type:'RESTRICT_BULK_VERIFY', val:false, company_id:data.company_id});
    }
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:(error.response?.data?.error?.includes('credits')) ?error.response.data.error :'An error occurred. Make sure you are integrated properly to '+data.enrich_type, type:'error'}});
  }
}


function * verifyBulkAsync(data){
  try{
    yield put({type:'REQUEST_LOAD_CONTACTS'});
    yield put({type:'RESTRICT_BULK_VERIFY', val:true, company_id:data.company_id});
    const api = yield call([axios, axios.get], '/api/emailEnrichment/bulkVerify/'+data.company_id)
    yield delay(3000);
    yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
    yield delay(3000);
    yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
    yield delay(3000);
    yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
    yield delay(5000);
    yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
    yield delay(10000);
    yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
    yield delay(20000);
    yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
    yield put({type:'RESTRICT_BULK_VERIFY', val:false, company_id:data.company_id});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:(error.response?.data?.error?.includes('credits')) ?error.response.data.error :'An error occurred. Make sure you are integrated properly to '+data.enrich_type, type:'error'}});
  }
}

function * verifyEmailAsync(data){
  try{
    yield put({type:'REQUEST_LOAD_CONTACTS'});
    const api = yield call([axios, axios.get], '/api/emailEnrichment/verification/'+data.contact_id+'/'+data.company_id)
    yield put({type:'REQUEST_VERIFY_NOW_SUCCESS', val:api.data.contact});
    //CREATE DELETE TIMELINE ITEMS;
    if(api.data.timeline_items!=undefined && api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data}); for(let ti of api.data.timeline_items){yield put({type:'REQUEST_SELECTED_TIMELINE_ITEM', val:ti.id});}}if(api.data.deleted_timeline_items!=undefined){for(let ti of api.data.deleted_timeline_items){yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));}}

  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:(error.response?.data?.error?.includes('credits')) ?error.response.data.error :'An error occurred. Make sure you are integrated properly to '+data.enrich_type, type:'error'}});
  }
}

function * getPhoneNumberNowAsync(data){
  try{
    yield put({type:'REQUEST_LOAD_CONTACTS'});
    const api = yield call([axios, axios.get], '/api/emailEnrichment/getPhoneNumberNow/'+data.contact_id+'/'+data.company_id)
    yield put({type:'REQUEST_GET_PHONE_NUMBER_NOW_SUCCESS', val:api.data.contact});
    //CREATE DELETE TIMELINE ITEMS;
    if(api.data.timeline_items!=undefined && api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data}); for(let ti of api.data.timeline_items){yield put({type:'REQUEST_SELECTED_TIMELINE_ITEM', val:ti.id});}}if(api.data.deleted_timeline_items!=undefined){for(let ti of api.data.deleted_timeline_items){yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));}}

  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:(error.response?.data?.error?.includes('credits')) ?error.response.data.error :'An error occurred. Make sure you are integrated properly to '+data.enrich_type, type:'error'}});
  }
}

function * getEmailNowAsync(data){
  try{
    yield put({type:'REQUEST_LOAD_CONTACTS'});
    const api = yield call([axios, axios.get], '/api/emailEnrichment/getEmailNow/'+data.contact_id+'/'+data.company_id)
    yield put({type:'REQUEST_GET_EMAIL_NOW_SUCCESS', val:api.data.contact});
    //CREATE DELETE TIMELINE ITEMS;
    if(api.data.timeline_items!=undefined && api.data.timeline_items.length>0){yield put({type:'REQUEST_TIMELINE_ITEM_CHECKLIST_SUCCESS', val:api.data}); for(let ti of api.data.timeline_items){yield put({type:'REQUEST_SELECTED_TIMELINE_ITEM', val:ti.id});}}if(api.data.deleted_timeline_items!=undefined){for(let ti of api.data.deleted_timeline_items){yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));}}
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'SET_SNACKBAR', val:{open:true, message:(error.response?.data?.error?.includes('credits')) ?error.response.data.error :'An error occurred. Make sure you are integrated properly to '+data.enrich_type, type:'error'}});
  }
}

function * deleteTimelineItemsAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/deleteTimelineItems', data.payload)
    yield put({type:'REQUEST_BULK_DELETE_TIMELINE_ITEMS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}


function * callManagerFollowUpTaskAsync(data){
  try{
    const api = yield call([axios, axios.post], '/api/callManagerFollowUpTask', data.payload)
    yield put({type:'REQUEST_TIMELINE_ITEM_CREATE_SUCCESS', val:api.data});
    //REFRESH DEAL;
    if(api.data.delete_timeline_items!=undefined){for(let ti of api.data.delete_timeline_items){yield(put({type:'REQUEST_TIMELINE_ITEM_DELETE_SUCCESS', val:ti}));}}
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_FORM_ERROR', val:error.response})
  }
}



function * updateDuplicatesAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/updateDuplicates', data.payload)
    yield put({type:'REQUEST_UPDATE_BATCH_DUPLICATES_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function * updateContactCompanyRelationsAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/contacts/companies/relations', data.payload)
    yield put({type:'REQUEST_UPDATE_CONTACT_COMPANY_RELATIONS_SUCCESS', val:api.data});
    yield put({ type: 'REQUEST_CONTACTS_INDEX', company_id:data.company_id});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}

function * manageCrmConnectionAsync(data){
  try{
    const api = yield call([axios, axios.put], '/api/externalCrms/resources/manageCrmConnection', data.payload)
    yield put({type:'REQUEST_MANAGE_CRM_CONNECTION_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response})
  }
}


function* Automated_search(){yield takeEvery('REQUEST_AUTOMATED_SEARCH', automatedSearchAsync);}
function* Automated_search_preview(){yield takeEvery('REQUEST_AUTOMATED_SEARCH_PREVIEW', automatedSearchPreviewAsync);}

function* Index_companies(){yield takeEvery('REQUEST_INDEX_COMPANIES', companiesIndexAsync);}
function* Edit_field_companies(){yield takeEvery('REQUEST_EDIT_FIELD_COMPANIES', companiesEditFieldAsync);}
function* Assign_companies(){yield takeEvery('REQUEST_ASSIGN_COMPANIES', companiesAssignAsync);}
function* Delete_companies(){yield takeEvery('REQUEST_DELETE_COMPANIES', companiesDeleteAsync);}
function* Move_companies(){yield takeEvery('REQUEST_MOVE_COMPANIES', companiesMoveAsync);}
function* Share_companies(){yield takeEvery('REQUEST_SHARE_COMPANIES', companiesShareAsync);}

function* Create_company(){yield takeEvery('REQUEST_COMPANY_CREATE', companyCreateAsync);}
function* Create_company_batch(){yield takeEvery('REQUEST_COMPANY_CREATE_BATCH', companyCreateBatchAsync);}
function* Delete_company(){yield takeEvery('REQUEST_COMPANY_DELETE', companyDeleteAsync);}
function* Update_company(){yield takeEvery('REQUEST_COMPANY_UPDATE', companyUpdateAsync);}
function* Get_company(){yield takeEvery('REQUEST_COMPANY_GET', companyGetAsync);}

function* Delete_contact(){yield takeEvery('REQUEST_CONTACT_DELETE', contactDeleteAsync);}
function* Create_contact(){yield takeEvery('REQUEST_CONTACT_CREATE', contactCreateAsync);}
function* Index_contacts(){yield takeEvery('REQUEST_CONTACTS_INDEX', contactIndexAsync);}
function* Update_contact(){yield takeEvery('REQUEST_CONTACT_UPDATE', contactUpdateAsync);}
function* Update_contact_company_relations(){yield takeEvery('REQUEST_UPDATE_CONTACT_COMPANY_RELATIONS', updateContactCompanyRelationsAsync);}

function* Merge_contact(){yield takeEvery('REQUEST_CONTACT_MERGE', contactMergeAsync);}
function* Merge_company(){yield takeEvery('REQUEST_COMPANY_MERGE', companyMergeAsync);}

function* Get_timeline_items(){yield takeEvery('REQUEST_TIMELINE_ITEMS_GET', timelineItemsGetAsync);}
function* Create_timeline_item(){yield takeEvery('REQUEST_TIMELINE_ITEM_CREATE', timelineItemCreateAsync);}
function* Update_timeline_item(){yield takeEvery('REQUEST_TIMELINE_ITEM_UPDATE', timelineItemUpdateAsync)}
function* Complete_task(){yield takeEvery('REQUEST_COMPLETE_TASK', taskCompleteAsync);}
function* Delete_timeline_item(){yield takeEvery('REQUEST_TIMELINE_ITEM_DELETE', timelineItemDeleteAsync)}
function* Delete_bulk_timeline_item(){yield takeEvery('REQUEST_DELETE_TIMELINE_ITEMS', deleteTimelineItemsAsync);}

function* Send_email_now(){yield takeEvery('REQUEST_SEND_EMAIL_NOW', sendEmailNowAsync);}
function* Cancel_email_now(){yield takeEvery('REQUEST_CANCEL_EMAIL_NOW', cancelEmailNowAsync);}

function* Add_to_companies(){yield takeEvery('REQUEST_ADD_TO_COMPANIES', addToCompaniesAsync);}


function* Enrich_emails(){yield takeEvery('REQUEST_ENRICH_EMAILS', enrichEmailsAsync);}
function* Verify_email(){yield takeEvery('REQUEST_VERIFY_NOW', verifyEmailAsync);}
function* Verify_bulk(){yield takeEvery('REQUEST_BULK_VERIFY_EMAILS', verifyBulkAsync);}
function* Get_phone_number_now(){yield takeEvery('REQUEST_GET_PHONE_NUMBER_NOW', getPhoneNumberNowAsync);}
function* Get_email_now(){yield takeEvery('REQUEST_GET_EMAIL_NOW', getEmailNowAsync);}
function* Call_manager_follow_up_task(){yield takeEvery('REQUEST_CREATE_CALL_MANAGER_FOLLOW_UP_TASK', callManagerFollowUpTaskAsync);}

function* Update_duplicates(){yield takeEvery('REQUEST_UPDATE_BATCH_DUPLICATES', updateDuplicatesAsync);}

function* Manage_crm_connection(){yield takeEvery('REQUEST_MANAGE_CRM_CONNECTION', manageCrmConnectionAsync);}

export default function* Root_companies(){
  yield all([
    fork(Automated_search),
    fork(Automated_search_preview),
    fork(Create_company),
    fork(Index_companies),
    fork(Edit_field_companies),
    fork(Assign_companies),
    fork(Delete_companies),
    fork(Move_companies),
    fork(Share_companies),
    fork(Delete_company),
    fork(Update_company),
    fork(Get_company),
    fork(Create_company_batch),
    fork(Delete_contact),
    fork(Create_contact),
    fork(Update_contact),
    fork(Update_contact_company_relations),
    fork(Index_contacts),
    fork(Merge_contact),
    fork(Merge_company),
    fork(Manage_crm_connection),
    fork(Get_timeline_items),
    fork(Create_timeline_item),
    fork(Update_timeline_item),
    fork(Delete_timeline_item),
    fork(Delete_bulk_timeline_item),
    fork(Send_email_now),
    fork(Cancel_email_now),
    fork(Add_to_companies),
    fork(Enrich_emails),
    fork(Verify_email),
    fork(Verify_bulk),
    fork(Get_phone_number_now),
    fork(Get_email_now),
    fork(Call_manager_follow_up_task),
    fork(Complete_task),
    fork(Update_duplicates)
  ])}
